<template>
  <div class="">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "IncomeStatementTabs",
  data() {
    return {
    };
  },
  props: {
    detailed: {
      default: false
    },
    hasDetailed: {
      default: false
    },
  },
  mounted() {
  },
  computed: {
    selectedTab() {
      if (this.hasDetailed){
        if (this.detailed) {
          return 1
        } else {
          return 0
        }
      }
      else {
        return 0
      }
    },
    tabs() {
      if (this.hasDetailed){
        return [
          {title: 'صورت سود و زیان کلی', detailed: false},
          {title: 'صورت سود و زیان جزئی', detailed: true},
        ]
      }
      else {
        return [
          {title: 'صورت سود و زیان کلی', detailed: false},
        ]
      }
    },
  },
  methods: {
    to(detailed) {
      if (detailed){
        return {
          name: "IncomeStatementReport",
          params: {
            detailed: "detailed",
          },
        };
      } else {
        return {
          name: "IncomeStatementReport",
        };
      }
    },

    changeRoute(tab) {
      this.$router.push(this.to(tab.detailed))
    }
  }

};
</script>

<style scoped lang="scss">
</style>

